import { render, staticRenderFns } from "./CasesOverview.vue?vue&type=template&id=d77a8466&scoped=true&"
import script from "./CasesOverview.vue?vue&type=script&lang=ts&"
export * from "./CasesOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77a8466",
  null
  
)

export default component.exports